module.exports = __webpack_public_path__ + "media/naruhodo.a69501a1.mp3";